<template>
    <div>
        <h1 class="title is-3 between-center">
            <span>Inspection Service Types</span>
            <div class="field is-grouped">
                <p v-if="isDeleteSelectedButtonVisible" class="control">
                    <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                </p>
                <p class="control">
                    <button @click="isInspectionServiceTypeModalActive = true" class="button is-info" ><span class="icon"><i class="icm-new"></i></span><span>New</span></button>
                </p>
            </div>
        </h1>
        <div class="columns">
            <div class="column">
                <o-table
                    :data="tableData"
                    :bordered="isBordered"
                    :striped="isStriped"
                    :narrowed="isNarrowed"
                    :checkable="isCheckable"
                    :loading="isLoading"
                    :mobile-cards="hasMobileCards"
                    :paginated="isPaginated"
                    :per-page="perPage"
                    :pagination-simple="isPaginationSimple"
                    default-sort="user.first_name"
                    :selected.sync="selected"
                    :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event">

                    <template slot-scope="props">
                        <o-table-column field="inspectionServiceType" label="Inspection Service Type" sortable>
                            {{ props.row.inspectionServiceType }}
                        </o-table-column>

                        <o-table-column field="status" label="Status" sortable>
                            {{ props.row.status }}
                        </o-table-column>
                    </template>

                    <div slot="empty" class="has-text-centered">
                        This table is empty!
                    </div>
                </o-table>
            </div>
        </div>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isInspectionServiceTypeModalActive">
            <inspection-service-type-modal></inspection-service-type-modal>
        </o-modal>
    </div>
</template>

<script>
    import InspectionServiceTypeModal from '../../components/modals/InspectionServiceType'

    export default {
        components: {
            InspectionServiceTypeModal,
        },

        data() {
            return {
                isInspectionServiceTypeModalActive: false,
                tableData: [
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                    {"id": 1, "inspectionServiceType": "Fire Alarm Test", "status": "Active"},
                    {"id": 2, "inspectionServiceType": "Soils - Site Preparation", "status": "Active"},
                    {"id": 3, "inspectionServiceType": "Underpinning", "status": "Active"},
                ],
                checkedRows: [],
                selected: {},
                isBordered: false,
                isStriped: true,
                isNarrowed: false,
                isCheckable: true,
                isLoading: false,
                hasMobileCards: true,
                isPaginated: true,
                isPaginationSimple: false,
                perPage: 10
            }
        },

        methods: {
            clearSelected() {
                this.selected = {}
            },
            clearCheckedRows() {
                this.checkedRows = []
            },
            confirmCustomDelete() {
                this.$swal.fire({
                    title: 'Deleting contact',
                    text: 'Are you sure you want to <strong>delete</strong> this contact? This action cannot be undone.',
                    confirmText: 'Delete Contact',
                    icon: 'error',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$swal.fire('Contact deleted!')
                    }
                })
            }
        },
        computed: {
            filteredDataArray() {
                return this.arrayExample.data.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.arrayExample.name.toLowerCase()) >= 0
                })
            },
            isDeleteSelectedButtonVisible () {
                return this.checkedRows.length
            },
        }
    }
</script>